import { useQuery, useMutation, gql } from '@apollo/client';
import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';

const NOOP = gql`
  mutation Noop {
    __typename
  }
`;

export const useGraphQl = (query, update) => {
  const [qVars, setQVars] = useState<any>(null);
  const [uVars, setUVars] = useState<any>(null);

  const {
    data: fetchData,
    loading,
    refetch,
    error: fetchError,
  } = useQuery(query, {
    variables: qVars,
    fetchPolicy: 'cache-and-network',
  });

  const [mutateData, { data: updateResponse, loading: updating, error: updateError }] = useMutation(
    update ?? NOOP
  );

  useEffect(() => {
    if (qVars) {
      refetch(qVars);
    }
  }, [qVars, refetch]);

  useEffect(() => {
    const error = updateError || fetchError;
    if (error) message.error(error.message);
  }, [updateError, fetchError]);

  const updateData = useCallback(
    async (variables) => {
      await mutateData({ variables });
    },
    [mutateData]
  );

  useEffect(() => {
    if (!uVars) return;
    updateData(uVars);
  }, [uVars, updateData]);

  return {
    loading,
    fetchError,
    fetchData,
    setQueryVariables: setQVars,
    setUpdateVariables: setUVars,
    updating,
    updateError,
    updateResponse,
  };
};
